"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Get cookie value by name.
 * @param name
 */
exports.GetCookie = (name) => {
    function escape(s) { return s.replace(/([.*+?\^${}()|\[\]\/\\])/g, '\\$1'); }
    var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
    return match ? match[1] : undefined;
};
/**
 * Expire(delete) cookie by name.
 * @param name
 */
exports.ExpireCookie = (name, domain) => {
    let cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
    if (domain) {
        cookie += ';domain=' + domain;
    }
    document.cookie = cookie;
};
exports.SetCookie = (cname, cvalue, domain) => {
    let cookie = cname + '=' + cvalue + ';SameSite=Strict;path=/';
    // The purpose of this is so that CM can see FOCUS session cookies.
    // CM uses these to determine if FOCUS is already open or not.
    // When CM is no longer supported, this COOKIEDOMAIN stuff can
    // be removed.
    if (domain) {
        cookie += ';domain=' + domain;
    }
    document.cookie = cookie;
};
//# sourceMappingURL=CookieManager.js.map